var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav"},[_c('ul',{staticClass:"nav-list"},[_c('li',{staticClass:"nav-list__item"},[_c('router-link',{staticClass:"router-link",attrs:{"to":{
          name: 'CreditCard',
          params: {
            stationId: this.$route.params.stationId,
            connectorId: this.$route.params.connectorId,
          },
        },"active-class":"active"}},[_vm._v("信用卡")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }